import { useEffect, useState, useRef } from "react";
import api from "../../api/client";

const PLANTILLAS = [
  { id: "clasica", label: "Clásica", desc: "Limpia y profesional, fondo blanco", emoji: "🏛️" },
  { id: "moderna", label: "Moderna", desc: "Oscura con acentos vibrantes", emoji: "🌙" },
  { id: "elegante", label: "Elegante", desc: "Minimalista y premium", emoji: "💎" },
  { id: "colorida", label: "Colorida", desc: "Festiva, perfecta para restaurantes", emoji: "🎨" },
  { id: "delivery", label: "Delivery", desc: "Estilo app de pedidos, grid con fotos", emoji: "🛵" },
  { id: "acordeon", label: "Acordeón", desc: "Hero de marca + categorías desplegables", emoji: "📋" },
];

const DIAS = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];
const TABS = ["General", "Horarios", "Pagos y WhatsApp", "Redes sociales", "Tasa BCV"];

/* ─── Simulador de menú ───────────────────────────────────────────────────── */
const DEMO_PRODS = [
  { id: 1, nombre: "Especial del día", precio: 9.99, foto_url: null },
  { id: 2, nombre: "Combo Popular", precio: 14.50, foto_url: null },
  { id: 3, nombre: "Favorito", precio: 7.99, foto_url: null },
  { id: 4, nombre: "Premium Mix", precio: 19.90, foto_url: null },
];
const DEMO_EMOJIS = ["🍕", "🍔", "🥤", "🍰"];

function Img({ url, fallbackEmoji, style = {} }) {
  const base = process.env.REACT_APP_API_URL || "http://localhost:8000";
  if (url) {
    return (
      <img
        src={`${base}${url}`}
        alt=""
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", ...style }}
      />
    );
  }
  return (
    <span style={{ fontSize: 22, lineHeight: 1, ...style }}>{fallbackEmoji}</span>
  );
}

function MenuSimulador({ nombre, descripcion, color, plantilla, logoUrl, bannerUrl, productos }) {
  const prods = productos.length ? productos.slice(0, 4) : DEMO_PRODS;
  const shopName = nombre || "Mi Tienda";
  const base = process.env.REACT_APP_API_URL || "http://localhost:8000";

  /* ── CLÁSICA: fondo blanco, tarjetas horizontales con imagen a la izquierda ── */
  if (plantilla === "clasica") {
    return (
      <div style={{ background: "#f3f4f6", height: "100%", overflowY: "auto", fontFamily: "system-ui, sans-serif" }}>
        <div style={{ background: "#fff", borderBottom: "2px solid " + color, padding: "8px 10px", display: "flex", alignItems: "center", gap: 8, position: "sticky", top: 0, zIndex: 10 }}>
          <div style={{ width: 28, height: 28, borderRadius: 6, background: color, overflow: "hidden", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
            {logoUrl ? <img src={`${base}${logoUrl}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <span style={{ fontSize: 14 }}>🛍️</span>}
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: 11, color: "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{shopName}</div>
            {descripcion && <div style={{ fontSize: 8, color: "#6b7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{descripcion}</div>}
          </div>
        </div>
        {bannerUrl && (
          <div style={{ height: 46, overflow: "hidden", position: "relative" }}>
            <img src={`${base}${bannerUrl}`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
        )}
        <div style={{ padding: "8px 10px" }}>
          <div style={{ fontSize: 8, fontWeight: 800, color: color, textTransform: "uppercase", letterSpacing: "0.08em", borderLeft: `3px solid ${color}`, paddingLeft: 6, marginBottom: 8 }}>
            Destacados
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {prods.map((p, i) => (
              <div key={p.id} style={{ background: "#fff", borderRadius: 8, display: "flex", alignItems: "center", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
                <div style={{ width: 52, height: 52, flexShrink: 0, background: "#f9fafb", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Img url={p.foto_url} fallbackEmoji={DEMO_EMOJIS[i]} />
                </div>
                <div style={{ flex: 1, padding: "5px 8px", minWidth: 0 }}>
                  <div style={{ fontSize: 9, fontWeight: 600, color: "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.nombre}</div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: color, marginTop: 2 }}>${Number(p.precio_promocion || p.precio).toFixed(2)}</div>
                </div>
                <div style={{ marginRight: 8, width: 20, height: 20, background: color, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: "#fff", fontWeight: 900, flexShrink: 0 }}>+</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ position: "sticky", bottom: 8, display: "flex", justifyContent: "center" }}>
          <div style={{ background: color, color: "#fff", borderRadius: 20, padding: "5px 14px", fontSize: 9, fontWeight: 700, boxShadow: "0 4px 12px rgba(0,0,0,0.2)" }}>
            🛒 Ver pedido · $24.48
          </div>
        </div>
      </div>
    );
  }

  /* ── MODERNA: fondo oscuro, grid 2 col con borde neón superior ── */
  if (plantilla === "moderna") {
    return (
      <div style={{ background: "#0a0a0f", height: "100%", overflowY: "auto", fontFamily: "system-ui, sans-serif" }}>
        <div style={{ background: "linear-gradient(135deg,#1a1a2e,#16213e)", borderBottom: `1px solid ${color}44`, padding: "8px 10px", display: "flex", alignItems: "center", gap: 8, position: "sticky", top: 0, zIndex: 10 }}>
          <div style={{ width: 28, height: 28, borderRadius: 6, background: `${color}22`, border: `1px solid ${color}66`, overflow: "hidden", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
            {logoUrl ? <img src={`${base}${logoUrl}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <span style={{ fontSize: 13, color }}>✦</span>}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: 11, color: "#fff", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{shopName}</div>
          </div>
          <div style={{ fontSize: 7, color: color, border: `1px solid ${color}`, borderRadius: 10, padding: "2px 6px", fontWeight: 700, flexShrink: 0 }}>OPEN</div>
        </div>
        {bannerUrl && (
          <div style={{ height: 44, overflow: "hidden", position: "relative", opacity: 0.7 }}>
            <img src={`${base}${bannerUrl}`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
        )}
        <div style={{ padding: "8px 10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
            <div style={{ flex: 1, height: 1, background: `${color}44` }} />
            <span style={{ fontSize: 8, color, fontWeight: 700, letterSpacing: "0.12em" }}>MENÚ</span>
            <div style={{ flex: 1, height: 1, background: `${color}44` }} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 7 }}>
            {prods.map((p, i) => (
              <div key={p.id} style={{ background: "#1a1a2e", borderRadius: 10, overflow: "hidden", border: `1px solid ${color}33`, boxShadow: `0 0 12px ${color}22` }}>
                <div style={{ height: 58, background: "#0d0d1a", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Img url={p.foto_url} fallbackEmoji={DEMO_EMOJIS[i]} style={p.foto_url ? { opacity: 0.85 } : { fontSize: 26 }} />
                  <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: color }} />
                </div>
                <div style={{ padding: "5px 6px" }}>
                  <div style={{ fontSize: 8, color: "#e2e8f0", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.nombre}</div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 4 }}>
                    <span style={{ fontSize: 9, color, fontWeight: 700 }}>${Number(p.precio_promocion || p.precio).toFixed(2)}</span>
                    <div style={{ width: 17, height: 17, background: color, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, color: "#000", fontWeight: 900 }}>+</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ position: "sticky", bottom: 8, display: "flex", justifyContent: "center" }}>
          <div style={{ background: color, color: "#000", borderRadius: 20, padding: "5px 14px", fontSize: 9, fontWeight: 700, boxShadow: `0 0 18px ${color}88` }}>
            🛒 Ver pedido · $52.38
          </div>
        </div>
      </div>
    );
  }

  /* ── ELEGANTE: crema, serif, tarjetas tipo menú de restaurante fino ── */
  if (plantilla === "elegante") {
    return (
      <div style={{ background: "#faf9f6", height: "100%", overflowY: "auto", fontFamily: "Georgia,'Times New Roman',serif" }}>
        <div style={{ background: "#faf9f6", borderBottom: "1px solid #e7e0d8", padding: "10px 12px", textAlign: "center", position: "sticky", top: 0, zIndex: 10 }}>
          {logoUrl && (
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 4 }}>
              <div style={{ width: 28, height: 28, borderRadius: "50%", overflow: "hidden", position: "relative" }}>
                <img src={`${base}${logoUrl}`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
              </div>
            </div>
          )}
          <div style={{ fontWeight: 700, fontSize: 11, color: "#292524", letterSpacing: "0.07em" }}>{shopName.toUpperCase()}</div>
          {descripcion && <div style={{ fontSize: 7, color: "#a8a29e", marginTop: 2, letterSpacing: "0.04em" }}>{descripcion.slice(0, 38)}</div>}
        </div>
        {bannerUrl && (
          <div style={{ height: 42, overflow: "hidden", position: "relative", opacity: 0.9 }}>
            <img src={`${base}${bannerUrl}`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
        )}
        <div style={{ padding: "10px 12px" }}>
          <div style={{ textAlign: "center", marginBottom: 10 }}>
            <span style={{ fontSize: 8, color: "#a8a29e", letterSpacing: "0.18em" }}>— Nuestra Selección —</span>
          </div>
          {prods.map((p, i, arr) => (
            <div key={p.id} style={{ display: "flex", alignItems: "center", padding: "9px 0", borderBottom: i < arr.length - 1 ? "1px solid #ede8e3" : "none", gap: 8 }}>
              <div style={{ width: 36, height: 36, borderRadius: "50%", overflow: "hidden", flexShrink: 0, background: "#f0ece7", border: "1px solid #e7e0d8", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {p.foto_url
                  ? <img src={`${base}${p.foto_url}`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
                  : <span style={{ fontSize: 15 }}>{DEMO_EMOJIS[i]}</span>}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 9, color: "#292524", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.nombre}</div>
                {p.descripcion && <div style={{ fontSize: 7, color: "#a8a29e", marginTop: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.descripcion}</div>}
              </div>
              <div style={{ flexShrink: 0, textAlign: "right" }}>
                <div style={{ fontSize: 10, color: "#292524", fontWeight: 700 }}>${Number(p.precio_promocion || p.precio).toFixed(2)}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ position: "sticky", bottom: 8, display: "flex", justifyContent: "center" }}>
          <div style={{ background: "#292524", color: "#faf9f6", borderRadius: 20, padding: "5px 16px", fontSize: 9, letterSpacing: "0.04em", fontFamily: "Georgia,serif" }}>
            Ver pedido · $52.38
          </div>
        </div>
      </div>
    );
  }

  /* ── DELIVERY: estilo app (Rappi/Uber Eats), grid 2 col, fotos full-bleed ── */
  if (plantilla === "delivery") {
    return (
      <div style={{ background: "#f7f8fa", height: "100%", overflowY: "auto", fontFamily: "system-ui, sans-serif" }}>
        <div style={{ background: "#fff", padding: "8px 10px", display: "flex", alignItems: "center", gap: 8, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", position: "sticky", top: 0, zIndex: 10 }}>
          <div style={{ width: 28, height: 28, borderRadius: 8, background: color, overflow: "hidden", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
            {logoUrl ? <img src={`${base}${logoUrl}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <span style={{ fontSize: 14 }}>🛵</span>}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 800, fontSize: 11, color: "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{shopName}</div>
          </div>
          <div style={{ fontSize: 7, background: color, color: "#fff", borderRadius: 8, padding: "2px 6px", fontWeight: 700, flexShrink: 0 }}>Abierto</div>
        </div>
        {bannerUrl && (
          <div style={{ height: 44, overflow: "hidden", position: "relative" }}>
            <img src={`${base}${bannerUrl}`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
        )}
        <div style={{ padding: "8px" }}>
          <div style={{ fontSize: 8, fontWeight: 800, color: "#111", marginBottom: 8, paddingLeft: 2 }}>Lo más pedido</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            {prods.map((p, i) => (
              <div key={p.id} style={{ borderRadius: 12, overflow: "hidden", background: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.10)", position: "relative", aspectRatio: "1/1" }}>
                <div style={{ position: "absolute", inset: 0, background: p.foto_url ? "#f0f0f0" : `linear-gradient(135deg, ${color}cc, ${color}88)`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {p.foto_url
                    ? <img src={`${base}${p.foto_url}`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
                    : <span style={{ fontSize: 32, opacity: 0.5, color: "#fff" }}>{DEMO_EMOJIS[i]}</span>}
                </div>
                <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "linear-gradient(transparent, rgba(0,0,0,0.72))", padding: "18px 7px 7px" }}>
                  <div style={{ fontSize: 8, fontWeight: 700, color: "#fff", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.nombre}</div>
                  <div style={{ fontSize: 9, color: "#fff", fontWeight: 800, marginTop: 1 }}>${Number(p.precio_promocion || p.precio).toFixed(2)}</div>
                </div>
                <div style={{ position: "absolute", top: 5, right: 5, width: 20, height: 20, background: color, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: "#fff", fontWeight: 900, boxShadow: "0 2px 6px rgba(0,0,0,0.3)" }}>+</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ position: "sticky", bottom: 8, display: "flex", justifyContent: "center" }}>
          <div style={{ background: color, color: "#fff", borderRadius: 20, padding: "5px 14px", fontSize: 9, fontWeight: 700, boxShadow: "0 4px 12px rgba(0,0,0,0.2)" }}>
            🛒 Ver pedido · $52.38
          </div>
        </div>
      </div>
    );
  }

  /* ── ACORDEÓN: hero de color + categorías desplegables ── */
  if (plantilla === "acordeon") {
    return (
      <div style={{ background: "#f7f7f7", height: "100%", overflowY: "auto", fontFamily: "system-ui, sans-serif" }}>
        {/* Hero */}
        <div style={{ background: color, padding: "12px 10px 10px", textAlign: "center" }}>
          <div style={{ width: 34, height: 34, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.95)", overflow: "hidden", margin: "0 auto 6px", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
            {logoUrl
              ? <img src={`${base}${logoUrl}`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
              : <span style={{ fontSize: 16, color: "#fff", fontWeight: 900 }}>{shopName.charAt(0)}</span>}
          </div>
          <div style={{ color: "#fff", fontWeight: 900, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.07em" }}>{shopName}</div>
          {descripcion && <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 7, marginTop: 2, fontStyle: "italic" }}>{descripcion.slice(0, 40)}</div>}
        </div>
        {bannerUrl && (
          <div style={{ height: 36, overflow: "hidden" }}>
            <img src={`${base}${bannerUrl}`} alt="" style={{ width: "100%", height: 36, objectFit: "cover", display: "block", opacity: 0.55 }} />
          </div>
        )}
        {/* Accordion categories */}
        <div style={{ padding: "7px 8px" }}>
          {prods.map((p, i) => (
            <div key={p.id} style={{ background: "#fff", borderRadius: 10, marginBottom: 6, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.07)" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "7px 10px", borderLeft: `4px solid ${color}` }}>
                <span style={{ fontSize: 8, fontWeight: 900, color, textTransform: "uppercase", letterSpacing: "0.09em" }}>Categoría {i + 1}</span>
                <span style={{ color: "#9ca3af", fontSize: 12 }}>▾</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 7, padding: "6px 10px 7px", borderTop: "1px solid #f3f4f6" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 8, fontWeight: 700, color: "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.nombre}</div>
                  <div style={{ fontSize: 9, color, fontWeight: 900, marginTop: 2 }}>${Number(p.precio).toFixed(2)}</div>
                </div>
                <div style={{ fontSize: 7, background: color, color: "#fff", borderRadius: 10, padding: "3px 8px", fontWeight: 700, flexShrink: 0 }}>AGREGAR</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ position: "sticky", bottom: 8, display: "flex", justifyContent: "center" }}>
          <div style={{ background: color, color: "#fff", borderRadius: 20, padding: "5px 14px", fontSize: 9, fontWeight: 700 }}>
            🛒 Ver pedido · $24.48
          </div>
        </div>
      </div>
    );
  }

  /* ── COLORIDA: gradiente vibrante, tarjetas blancas flotantes ── */
  return (
    <div style={{ background: `linear-gradient(145deg, ${color} 0%, ${color}bb 60%, ${color}88 100%)`, height: "100%", overflowY: "auto", fontFamily: "system-ui, sans-serif" }}>
      <div style={{ background: "rgba(255,255,255,0.96)", margin: "8px 8px 0", borderRadius: 14, padding: "6px 10px", display: "flex", alignItems: "center", gap: 7, boxShadow: "0 2px 10px rgba(0,0,0,0.12)" }}>
        <div style={{ width: 27, height: 27, borderRadius: "50%", background: color, overflow: "hidden", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
          {logoUrl ? <img src={`${base}${logoUrl}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <span style={{ fontSize: 13 }}>🎉</span>}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 800, fontSize: 11, color: "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{shopName}</div>
          {descripcion && <div style={{ fontSize: 7, color: "#6b7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{descripcion}</div>}
        </div>
        <div style={{ fontSize: 7, background: color, color: "#fff", borderRadius: 8, padding: "2px 6px", fontWeight: 800, flexShrink: 0 }}>ABIERTO</div>
      </div>
      {bannerUrl && (
        <div style={{ margin: "6px 8px 0", borderRadius: 10, height: 40, overflow: "hidden", position: "relative" }}>
          <img src={`${base}${bannerUrl}`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
      )}
      <div style={{ padding: "8px 8px" }}>
        <div style={{ color: "rgba(255,255,255,0.95)", fontSize: 9, fontWeight: 800, marginBottom: 8, textAlign: "center", textShadow: "0 1px 3px rgba(0,0,0,0.25)" }}>
          ✨ Lo más pedido
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 7 }}>
          {prods.map((p, i) => (
            <div key={p.id} style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 4px 14px rgba(0,0,0,0.18)" }}>
              <div style={{ height: 56, background: "#f8f9fa", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Img url={p.foto_url} fallbackEmoji={DEMO_EMOJIS[i]} style={p.foto_url ? {} : { fontSize: 28 }} />
              </div>
              <div style={{ padding: "5px 7px 7px" }}>
                <div style={{ fontSize: 8, fontWeight: 700, color: "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.nombre}</div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 4 }}>
                  <span style={{ fontSize: 8, background: color, color: "#fff", padding: "2px 6px", borderRadius: 8, fontWeight: 800 }}>${Number(p.precio_promocion || p.precio).toFixed(2)}</span>
                  <div style={{ width: 19, height: 19, background: color, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: "#fff", fontWeight: 900 }}>+</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ position: "sticky", bottom: 8, display: "flex", justifyContent: "center" }}>
        <div style={{ background: "#fff", color, borderRadius: 20, padding: "5px 14px", fontSize: 9, fontWeight: 800, boxShadow: "0 4px 16px rgba(0,0,0,0.22)" }}>
          🛒 Ver pedido · $52.38
        </div>
      </div>
    </div>
  );
}

/* ─── Marco de celular ────────────────────────────────────────────────────── */
function PhoneFrame({ children, plantilla, color }) {
  const frames = {
    clasica:  { border: "#9ca3af", bg: "#e5e7eb", notch: "#9ca3af" },
    moderna:  { border: "#1e293b", bg: "#0f172a",  notch: "#1e293b" },
    elegante: { border: "#c4b5a0", bg: "#e7e0d8",  notch: "#c4b5a0" },
    colorida: { border: color,     bg: color,       notch: color },
    delivery: { border: "#374151", bg: "#1f2937",   notch: "#374151" },
    acordeon: { border: color,     bg: `${color}dd`, notch: color },
  };
  const f = frames[plantilla] || frames.clasica;
  return (
    <div className="flex flex-col items-center">
      <div
        style={{
          width: 200,
          height: 400,
          borderRadius: 28,
          border: `6px solid ${f.border}`,
          background: f.bg,
          boxShadow: "0 20px 60px rgba(0,0,0,0.25), inset 0 0 0 1px rgba(255,255,255,0.08)",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div style={{
          position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)",
          width: 56, height: 14, background: f.notch,
          borderRadius: "0 0 10px 10px", zIndex: 20,
        }} />
        <div style={{ width: "100%", height: "100%", overflowY: "auto", overflowX: "hidden" }}>
          {children}
        </div>
      </div>
      <div style={{ width: 48, height: 4, background: f.border, borderRadius: 2, marginTop: 8 }} />
      <p className="text-xs text-gray-400 mt-2 text-center">Vista previa del catálogo</p>
    </div>
  );
}

/* ─── Página principal ────────────────────────────────────────────────────── */
export default function Configuracion() {
  const [tab, setTab] = useState(0);
  const [config, setConfig] = useState(null);
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [previewForm, setPreviewForm] = useState(null);
  const logoRef = useRef();
  const bannerRef = useRef();

  useEffect(() => {
    Promise.all([
      api.get("/config/"),
      api.get("/productos/?page=1&page_size=4&solo_activos=true"),
    ]).then(([cfg, prods]) => {
      setConfig(cfg.data);
      setProductos(prods.data.items || []);
    }).finally(() => setLoading(false));
  }, []);

  const guardar = async (patch) => {
    setSaving(true);
    setMsg("");
    try {
      const { data } = await api.put("/config/", patch);
      setConfig(data);
      setPreviewForm(null);
      setMsg("¡Guardado correctamente!");
      setTimeout(() => setMsg(""), 3000);
    } catch {
      setMsg("Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  const subirImagen = async (tipo, file) => {
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post(`/config/${tipo}`, fd);
      setConfig(data);
      setMsg("Imagen actualizada");
      setTimeout(() => setMsg(""), 3000);
    } catch {
      setMsg("Error al subir imagen");
    }
  };

  if (loading) return (
    <div className="flex items-center justify-center h-40">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
    </div>
  );

  const preview = previewForm || config;

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Configuración</h2>
        <p className="text-gray-500 text-sm mt-1">Personaliza tu catálogo digital</p>
      </div>

      {msg && (
        <div className={`mb-4 px-4 py-3 rounded-lg text-sm ${msg.includes("Error") ? "bg-red-50 text-red-700 border border-red-200" : "bg-green-50 text-green-700 border border-green-200"}`}>
          {msg}
        </div>
      )}

      {/* Tabs */}
      <div className="flex gap-1 bg-gray-100 rounded-xl p-1 mb-6 overflow-x-auto">
        {TABS.map((t, i) => (
          <button key={i} onClick={() => setTab(i)}
            className={`flex-shrink-0 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${tab === i ? "bg-white shadow text-indigo-700" : "text-gray-500 hover:text-gray-700"}`}>
            {t}
          </button>
        ))}
      </div>

      {/* Layout: form + simulador en tab General */}
      {tab === 0 ? (
        <div className="flex flex-col xl:flex-row gap-6">
          {/* Formulario */}
          <div className="flex-1 bg-white rounded-xl shadow-sm p-6">
            <GeneralTab
              config={config}
              onSave={guardar}
              logoRef={logoRef}
              bannerRef={bannerRef}
              onUpload={subirImagen}
              saving={saving}
              onPreviewChange={setPreviewForm}
            />
          </div>

          {/* Simulador */}
          <div className="xl:w-72 flex flex-col items-center">
            <div className="bg-white rounded-xl shadow-sm p-6 w-full flex flex-col items-center sticky top-4">
              <div className="flex items-center gap-2 mb-5 self-start">
                <span className="text-lg">📱</span>
                <h3 className="font-semibold text-gray-700 text-sm">Simulador en vivo</h3>
              </div>
              <PhoneFrame plantilla={preview?.plantilla || "clasica"} color={preview?.color_tema || "#3B82F6"}>
                <MenuSimulador
                  nombre={preview?.nombre_comercio || ""}
                  descripcion={preview?.descripcion || ""}
                  color={preview?.color_tema || "#3B82F6"}
                  plantilla={preview?.plantilla || "clasica"}
                  logoUrl={config?.logo_url}
                  bannerUrl={config?.banner_url}
                  productos={productos}
                />
              </PhoneFrame>
              <p className="text-xs text-gray-400 text-center mt-4 leading-relaxed">
                Los cambios se reflejan aquí<br />al guardar o al escribir
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm p-6">
          {tab === 1 && <HorariosTab config={config} onSave={guardar} saving={saving} />}
          {tab === 2 && <PagosTab config={config} onSave={guardar} saving={saving} />}
          {tab === 3 && <RedesTab config={config} onSave={guardar} saving={saving} />}
          {tab === 4 && <TasaBCVTab config={config} onSave={guardar} />}
        </div>
      )}
    </div>
  );
}

/* ─── Tab General ────────────────────────────────────────────────────────── */
function GeneralTab({ config, onSave, logoRef, bannerRef, onUpload, saving, onPreviewChange }) {
  const [form, setForm] = useState({
    nombre_comercio: config?.nombre_comercio || "",
    descripcion: config?.descripcion || "",
    plantilla: config?.plantilla || "clasica",
    color_tema: config?.color_tema || "#3B82F6",
  });

  const update = (patch) => {
    const next = { ...form, ...patch };
    setForm(next);
    onPreviewChange(next);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del comercio</label>
          <input
            value={form.nombre_comercio}
            onChange={(e) => update({ nombre_comercio: e.target.value })}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder="Mi Tienda"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Color del tema</label>
          <div className="flex items-center gap-3">
            <input
              type="color"
              value={form.color_tema}
              onChange={(e) => update({ color_tema: e.target.value })}
              className="h-10 w-14 border border-gray-300 rounded-lg cursor-pointer p-1"
            />
            <span className="text-sm text-gray-500 font-mono">{form.color_tema}</span>
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Descripción del comercio</label>
        <textarea
          value={form.descripcion}
          onChange={(e) => update({ descripcion: e.target.value })}
          rows={2}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none"
          placeholder="Breve descripción de tu negocio"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">Plantilla del catálogo</label>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {PLANTILLAS.map((p) => (
            <button
              key={p.id}
              type="button"
              onClick={() => update({ plantilla: p.id })}
              className={`border-2 rounded-xl p-3 text-left transition-all ${form.plantilla === p.id ? "border-indigo-500 bg-indigo-50 shadow-md" : "border-gray-200 hover:border-gray-300"}`}
            >
              <div className="text-2xl mb-1">{p.emoji}</div>
              <div className="font-medium text-sm text-gray-800">{p.label}</div>
              <div className="text-xs text-gray-500 mt-0.5 leading-tight">{p.desc}</div>
              {form.plantilla === p.id && (
                <div className="mt-2 text-xs font-semibold text-indigo-600">✓ Seleccionada</div>
              )}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Logo</label>
          {config?.logo_url && (
            <img src={`${process.env.REACT_APP_API_URL || "http://localhost:8000"}${config.logo_url}`} alt="Logo"
              className="w-20 h-20 object-contain rounded-lg border mb-2" />
          )}
          <input
            ref={logoRef}
            type="file"
            accept="image/*"
            onChange={(e) => e.target.files[0] && onUpload("logo", e.target.files[0])}
            className="text-sm text-gray-500 file:mr-2 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-xs file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Banner / portada</label>
          {config?.banner_url && (
            <img src={`${process.env.REACT_APP_API_URL || "http://localhost:8000"}${config.banner_url}`} alt="Banner"
              className="w-full h-20 object-cover rounded-lg border mb-2" />
          )}
          <input
            ref={bannerRef}
            type="file"
            accept="image/*"
            onChange={(e) => e.target.files[0] && onUpload("banner", e.target.files[0])}
            className="text-sm text-gray-500 file:mr-2 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-xs file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
          />
        </div>
      </div>

      <button
        onClick={() => onSave(form)}
        disabled={saving}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-6 py-2.5 rounded-lg text-sm font-medium"
      >
        {saving ? "Guardando..." : "Guardar cambios"}
      </button>
    </div>
  );
}

/* ─── Tab Horarios ───────────────────────────────────────────────────────── */
function HorariosTab({ config, onSave, saving }) {
  const [horarios, setHorarios] = useState(config?.horarios || {});

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">Configura el horario de atención de tu local</p>
      <div className="space-y-2">
        {DIAS.map((dia) => (
          <div key={dia} className="flex items-center gap-3">
            <span className="w-24 text-sm font-medium text-gray-700 capitalize">{dia}</span>
            <input
              value={horarios[dia] || ""}
              onChange={(e) => setHorarios({ ...horarios, [dia]: e.target.value })}
              placeholder="Ej: 8:00am - 6:00pm"
              className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <button onClick={() => setHorarios({ ...horarios, [dia]: "" })} className="text-gray-400 hover:text-gray-600 text-sm">✕</button>
          </div>
        ))}
      </div>
      <button onClick={() => onSave({ horarios })} disabled={saving}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-6 py-2.5 rounded-lg text-sm font-medium">
        {saving ? "Guardando..." : "Guardar horarios"}
      </button>
    </div>
  );
}

/* ─── Tab Pagos y WhatsApp ───────────────────────────────────────────────── */
function PagosTab({ config, onSave, saving }) {
  const [formas, setFormas] = useState(config?.formas_pago || {});
  const [wp, setWp] = useState(config?.whatsapp_config || { nombre: "", telefono: "", mensaje_personalizado: "" });

  const FORMAS_PAGO = [
    { key: "efectivo", label: "Efectivo" },
    { key: "transferencia", label: "Transferencia bancaria" },
    { key: "pago_movil", label: "Pago móvil" },
    { key: "zelle", label: "Zelle" },
    { key: "paypal", label: "PayPal" },
    { key: "binance", label: "Binance Pay" },
    { key: "tarjeta", label: "Tarjeta de crédito/débito" },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-medium text-gray-800 mb-3">Formas de pago aceptadas</h3>
        <div className="grid grid-cols-2 gap-2">
          {FORMAS_PAGO.map(({ key, label }) => (
            <label key={key} className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={!!formas[key]}
                onChange={() => setFormas((p) => ({ ...p, [key]: !p[key] }))}
                className="rounded border-gray-300 text-indigo-600" />
              <span className="text-sm text-gray-700">{label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="border-t pt-5">
        <h3 className="font-medium text-gray-800 mb-1">Configuración de WhatsApp</h3>
        <p className="text-xs text-gray-500 mb-3">Los pedidos se enviarán a este número</p>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Nombre del vendedor</label>
              <input value={wp.nombre} onChange={(e) => setWp({ ...wp, nombre: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Tu nombre" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Teléfono (con código país)</label>
              <input value={wp.telefono} onChange={(e) => setWp({ ...wp, telefono: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="+584121234567" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Mensaje personalizado (opcional)</label>
            <textarea value={wp.mensaje_personalizado} onChange={(e) => setWp({ ...wp, mensaje_personalizado: e.target.value })}
              rows={2} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none"
              placeholder="Hola! Quiero hacer este pedido..." />
          </div>
        </div>
      </div>

      <button onClick={() => onSave({ formas_pago: formas, whatsapp_config: wp })} disabled={saving}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-6 py-2.5 rounded-lg text-sm font-medium">
        {saving ? "Guardando..." : "Guardar configuración"}
      </button>
    </div>
  );
}

/* ─── Tab Redes sociales ─────────────────────────────────────────────────── */
function RedesTab({ config, onSave, saving }) {
  const [redes, setRedes] = useState(config?.redes_sociales || {});

  const REDES = [
    { key: "instagram", label: "Instagram", placeholder: "https://instagram.com/tutienda" },
    { key: "facebook", label: "Facebook", placeholder: "https://facebook.com/tutienda" },
    { key: "tiktok", label: "TikTok", placeholder: "https://tiktok.com/@tutienda" },
    { key: "twitter", label: "X / Twitter", placeholder: "https://twitter.com/tutienda" },
    { key: "youtube", label: "YouTube", placeholder: "https://youtube.com/@tutienda" },
    { key: "website", label: "Sitio web", placeholder: "https://tutienda.com" },
  ];

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">Agrega los enlaces de tus redes sociales</p>
      {REDES.map(({ key, label, placeholder }) => (
        <div key={key}>
          <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
          <input value={redes[key] || ""} onChange={(e) => setRedes({ ...redes, [key]: e.target.value })}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder={placeholder} />
        </div>
      ))}
      <button onClick={() => onSave({ redes_sociales: redes })} disabled={saving}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-6 py-2.5 rounded-lg text-sm font-medium">
        {saving ? "Guardando..." : "Guardar redes sociales"}
      </button>
    </div>
  );
}

/* ─── Tab Tasa BCV ───────────────────────────────────────────────────────── */
function TasaBCVTab({ config, onSave }) {
  const [tasas, setTasas] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actualizando, setActualizando] = useState(false);
  const [error, setError] = useState("");
  const [monedaBCV, setMonedaBCV] = useState(config?.moneda_bcv || "");
  const [tasaPersonalizada, setTasaPersonalizada] = useState(config?.tasa_bcv ? String(config.tasa_bcv) : "");
  const [fechaConsulta, setFechaConsulta] = useState("");
  const [resultadoFecha, setResultadoFecha] = useState(null);
  const [errorFecha, setErrorFecha] = useState("");
  const [buscandoFecha, setBuscandoFecha] = useState(false);

  const fmtFecha = (f) => {
    if (!f) return "";
    const [y, m, d] = f.split("-");
    const meses = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
    return `${parseInt(d)} ${meses[parseInt(m)-1]} ${y}`;
  };

  const cargar = async () => {
    try {
      const [u, h] = await Promise.all([
        api.get("/tasas/ultima").catch(() => null),
        api.get("/tasas/historial").catch(() => ({ data: [] })),
      ]);
      setTasas(u?.data || null);
      setHistorial(h.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const consultarPorFecha = async () => {
    if (!fechaConsulta) return;
    setBuscandoFecha(true);
    setResultadoFecha(null);
    setErrorFecha("");
    try {
      const { data } = await api.get(`/tasas/por-fecha/${fechaConsulta}`);
      setResultadoFecha(data);
    } catch (e) {
      setErrorFecha(e.response?.data?.detail || "No se encontró tasa para esa fecha");
    } finally {
      setBuscandoFecha(false);
    }
  };

  const guardarMoneda = async (valor) => {
    setMonedaBCV(valor);
    await onSave({ moneda_bcv: valor || null });
  };

  const actualizar = async (manual = null) => {
    if (manual) {
      try {
        const { data } = await api.put("/tasas/manual", manual);
        setTasas(data);
      } catch (e) {
        setError(e.response?.data?.detail || "Error al guardar");
      }
      return;
    }
    setActualizando(true);
    setError("");
    try {
      const { data } = await api.post("/tasas/actualizar");
      setTasas(data);
      await cargar();
    } catch (e) {
      setError(e.response?.data?.detail || "No se pudo conectar con el BCV");
    } finally {
      setActualizando(false);
    }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="font-semibold text-gray-800 mb-1">Tasa de cambio BCV</h3>
          <p className="text-sm text-gray-500">
            Se obtiene automáticamente cada día a las 12:00 AM desde el Banco Central de Venezuela.
          </p>
        </div>
        <button
          onClick={actualizar}
          disabled={actualizando}
          className="flex-shrink-0 flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors"
        >
          {actualizando
            ? <><span className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" /> Actualizando...</>
            : "Actualizar ahora"}
        </button>
      </div>

      {error && (
        <div className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3">{error}</div>
      )}

      {/* Tasas actuales */}
      {loading ? (
        <div className="flex justify-center py-8"><div className="w-7 h-7 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" /></div>
      ) : tasas ? (
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-green-50 border border-green-200 rounded-xl p-5">
            <p className="text-xs text-green-600 font-semibold uppercase tracking-wide mb-1">Dólar USD</p>
            <p className="text-3xl font-black text-green-700">
              {tasas.usd?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
            <p className="text-xs text-green-500 mt-1">Bs. por $1 USD</p>
            <p className="text-xs text-gray-400 mt-3">Fecha valor: {fmtFecha(tasas.fecha)}</p>
          </div>
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
            <p className="text-xs text-blue-600 font-semibold uppercase tracking-wide mb-1">Euro EUR</p>
            <p className="text-3xl font-black text-blue-700">
              {tasas.eur?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
            <p className="text-xs text-blue-500 mt-1">Bs. por €1 EUR</p>
            <p className="text-xs text-gray-400 mt-3">Fecha valor: {fmtFecha(tasas.fecha)}</p>
          </div>
        </div>
      ) : (
        <div className="bg-gray-50 border border-dashed border-gray-300 rounded-xl p-6 text-center">
          <p className="text-sm text-gray-400">Sin tasas registradas. Presiona "Actualizar ahora" para obtener la tasa del BCV.</p>
        </div>
      )}

      {/* Configuracion de equivalencia */}
      <div className="border border-gray-200 rounded-xl p-5">
        <h4 className="font-semibold text-gray-700 text-sm mb-1">Equivalencia en bolívares</h4>
        <p className="text-xs text-gray-400 mb-4">Selecciona qué tasa usar para mostrar el precio en Bs. junto al precio en USD en tu catálogo público.</p>
        <div className="space-y-2">
          {[
            { valor: "", label: "No mostrar equivalencia", desc: "Solo se muestra el precio en USD" },
            { valor: "usd", label: "Tasa Dólar (USD)", desc: tasas ? `1 USD = Bs. ${tasas.usd?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "Tasa del BCV" },
            { valor: "eur", label: "Tasa Euro (EUR)", desc: tasas ? `1 EUR = Bs. ${tasas.eur?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "Tasa del BCV" },
          ].map(({ valor, label, desc }) => (
            <label key={valor} className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${monedaBCV === valor ? "border-indigo-500 bg-indigo-50" : "border-gray-200 hover:bg-gray-50"}`}>
              <input type="radio" name="moneda_bcv" checked={monedaBCV === valor} onChange={() => guardarMoneda(valor)} className="accent-indigo-600" />
              <div>
                <p className={`text-sm font-semibold ${monedaBCV === valor ? "text-indigo-700" : "text-gray-700"}`}>{label}</p>
                <p className="text-xs text-gray-400">{desc}</p>
              </div>
            </label>
          ))}

          {/* Opcion tasa personalizada */}
          <div className={`p-3 rounded-lg border transition-colors ${monedaBCV === "manual" ? "border-indigo-500 bg-indigo-50" : "border-gray-200"}`}>
            <label className="flex items-center gap-3 cursor-pointer">
              <input type="radio" name="moneda_bcv" checked={monedaBCV === "manual"} onChange={() => guardarMoneda("manual")} className="accent-indigo-600" />
              <div>
                <p className={`text-sm font-semibold ${monedaBCV === "manual" ? "text-indigo-700" : "text-gray-700"}`}>Tasa personalizada</p>
                <p className="text-xs text-gray-400">Ingresa la tasa manualmente cuando el BCV no esté disponible</p>
              </div>
            </label>
            {monedaBCV === "manual" && (
              <div className="mt-3 flex items-center gap-2 ml-7">
                <span className="text-sm text-gray-500 whitespace-nowrap">Bs. por $1</span>
                <input
                  type="number" step="0.01" min="0"
                  value={tasaPersonalizada}
                  onChange={(e) => setTasaPersonalizada(e.target.value)}
                  onBlur={async (e) => {
                    const v = parseFloat(e.target.value);
                    if (v > 0) await onSave({ tasa_bcv: v, moneda_bcv: "manual" });
                  }}
                  className="w-36 border border-gray-300 rounded-lg px-3 py-1.5 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="517.96"
                  autoFocus
                />
                <span className="text-xs text-gray-400">Se guarda al salir del campo</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Consulta por fecha */}
      <div className="border border-gray-200 rounded-xl p-5">
        <h4 className="font-semibold text-gray-700 text-sm mb-1">Consultar tasa por fecha</h4>
        <p className="text-xs text-gray-400 mb-3">Busca la tasa del Banco Central registrada en una fecha específica.</p>
        <div className="flex gap-2">
          <input
            type="date"
            value={fechaConsulta}
            max={new Date().toISOString().split("T")[0]}
            onChange={(e) => { setFechaConsulta(e.target.value); setResultadoFecha(null); setErrorFecha(""); }}
            className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
          <button
            onClick={consultarPorFecha}
            disabled={!fechaConsulta || buscandoFecha}
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors whitespace-nowrap"
          >
            {buscandoFecha
              ? <><span className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" /> Buscando...</>
              : "Consultar"}
          </button>
        </div>

        {errorFecha && (
          <p className="text-xs text-red-500 mt-2">{errorFecha}</p>
        )}

        {resultadoFecha && (
          <div className="mt-3 grid grid-cols-2 gap-3">
            <div className="bg-green-50 border border-green-200 rounded-lg px-4 py-3">
              <p className="text-xs text-green-600 font-semibold mb-1">Dólar USD — {fmtFecha(resultadoFecha.fecha)}</p>
              <p className="text-2xl font-black text-green-700">
                {resultadoFecha.usd?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                <span className="text-xs font-normal text-green-500 ml-1">Bs./$</span>
              </p>
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3">
              <p className="text-xs text-blue-600 font-semibold mb-1">Euro EUR — {fmtFecha(resultadoFecha.fecha)}</p>
              <p className="text-2xl font-black text-blue-700">
                {resultadoFecha.eur?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                <span className="text-xs font-normal text-blue-500 ml-1">Bs./€</span>
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Historial */}
      {historial.length > 1 && (
        <div>
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Historial reciente</p>
          <div className="border border-gray-200 rounded-xl overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-gray-400 text-xs uppercase">
                <tr>
                  <th className="px-4 py-2 text-left">Fecha</th>
                  <th className="px-4 py-2 text-right">USD</th>
                  <th className="px-4 py-2 text-right">EUR</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {historial.slice(0, 7).map((t) => (
                  <tr key={t.fecha} className="hover:bg-gray-50">
                    <td className="px-4 py-2 text-gray-600">{fmtFecha(t.fecha)}</td>
                    <td className="px-4 py-2 text-right font-medium text-gray-800">
                      {t.usd?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td className="px-4 py-2 text-right font-medium text-gray-800">
                      {t.eur?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
